<script>
    import { tap } from "../store";
    import { scale } from "svelte/transition";
    import { bounceOut } from "svelte/easing";

    export let isBad = false;
    export let duration = 500;
    export let delay = 100;

    export let left;
    export let top;

    let styleString = isBad ? "bad" : "";
    let imageSource = isBad
        ? "images/jazz_note_bad.png"
        : "images/jazz_note.png";

    function handleTap() {
        tap({ isBad });
    }
</script>

<style>
    .note-tap {
        z-index: 2;
        width: 70px;
        height: 70px;
        cursor: pointer;
        user-select: none;
    }

    .bad {
        z-index: 1;
    }
</style>

<div
    class={`note-tap ${styleString} w-embed`}
    style={`left: ${left}; top: ${top}`}>
    <img
        in:scale={{ duration, delay, easing: bounceOut }}
        src={imageSource}
        alt=""
        class="image"
        on:mousedown={handleTap}
        on:touchstart={handleTap} />
</div>
